export enum AlignEnum {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}
